import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-agents-list',
  templateUrl: './client-agents-list.component.html',
  styleUrls: ['./client-agents-list.component.css']
})
export class ClientAgentsListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/client-agents-list/client-agents-list.component.ts